import { ChartConfig } from "@/components/ui/chart";
import { JobOrderStatus } from "./constants";

const barChartConfig = {
  tasks: { label: "Tasks" },
  notStarted: {
    label: JobOrderStatus.NotStarted,
    color: "var(--chart-6)",
  },
  wsi: {
    label: JobOrderStatus.WSI,
    color: "var(--chart-2)",
  },
  inProgress: {
    label: JobOrderStatus.InProgress,
    color: "var(--chart-3)",
  },
  repairInProgress: {
    label: JobOrderStatus.RepairInProgress,
    color: "var(--chart-4)",
  },
  evaluationInProgress: {
    label: JobOrderStatus.EvaluationInProgress,
    color: "var(--chart-5)",
  },

  pendingArcGeneration: {
    label: JobOrderStatus.PendingARCGeneration,
    color: "var(--chart-1)",
  },
  completed: {
    label: JobOrderStatus.Completed,
    color: "var(--chart-7)",
  },
  pendingCustomerApproval: {
    label: JobOrderStatus.PendingCustomerApproval,
    color: "var(--chart-8)",
  },
  pendingCSDQuotation: {
    label: JobOrderStatus.PendingCSDQuotation,
    color: "var(--chart-9)",
  },
  pendingSubcon: {
    label: JobOrderStatus.PendingSubcon,
    color: "var(--chart-10)",
  },
  pendingMaterial: {
    label: JobOrderStatus.PendingMaterial,
    color: "var(--chart-11)",
  },
  // hardCopy: {
  //   label: JobOrderStatus.HardCopy,
  //   color: 'hsl(var(--chart-12))',
  // },
} satisfies ChartConfig;

const pieChartConfigPriority = {
  tasks: { label: "Tasks" },
  Critical: { label: "Critical", color: "var(--chart-1)" },
  High: { label: "High", color: "var(--chart-9)" },
  Medium: { label: "Medium", color: "var(--chart-5)" },
  Low: { label: "Low", color: "var(--chart-8)" },
  Minor: { label: "Minor", color: "var(--chart-6)" },
} satisfies ChartConfig;

const stackBarChartConfig = {
  used: { label: "Used", color: "var(--chart-1)" },
  unused: { label: "Unused", color: "var(--chart-2)" },
} satisfies ChartConfig;

export { barChartConfig, pieChartConfigPriority, stackBarChartConfig };
